<template>
  <v-app>
    <UserAccounts></UserAccounts>
    <two-factor-authenticate></two-factor-authenticate>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5 lg4>
            <img src="../../assets/images/unoapp.png" class="form-head-logo mb-2"/>
            <v-card class="elevation-12 px-5">
              <offset-heading titleClass="text-center headline mb-2 font-weight-bold" title="LOGIN"></offset-heading>
              <v-card-text class="px-5 py-5 mt-7">
                <v-form ref="form-1" lazy-validation @submit.prevent="login($event)" onSubmit="return false;">
                  <v-text-field
                    v-model="user.email"
                    :rules="emailRules"
                    prepend-icon="fas fa-user-circle"
                    name="login"
                    label="Login"
                    required
                    validate-on-blur
                    @keyup.enter="login($event)"
                    type="text">
                  </v-text-field>
                  <v-text-field
                    v-model="user.password"
                    :rules="passwordRules"
                    prepend-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    validate-on-blur
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    @keyup.enter="login($event)"
                  >
                  </v-text-field>
                </v-form>
                <div class="px-5">
                  <router-link class="normal-link" :to="{ name: 'ForgotPassword'}"> Forgot your password?</router-link>
                  <br/>
                  <router-link class="normal-link inline-block mb-5" :to="{ name: 'LoginWithPhoneNumber'}"> Login using my phone number</router-link>
                  <br/>
                  <v-btn
                    color="primary"
                    d-inline-flex
                    fab
                    medium
                    @click="login($event)"
                  >
                    <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapActions } from 'vuex';
import Env from '@/env';
import NormalApi from '@/components/Controllers/NormalApi';
import AuthApi from '@/components/Controllers/AuthApis';
import moment from 'moment';

export default {
  name: 'Login',
  data() {
    return {
      showPassword: false,
      user: {
        email: '',
        password: '',
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^.+@.+\..+$/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be more than 8 characters',
      ],
      passwordCheckRules: [
        v => !!v || 'Password is required',
        v => v === this.newPassword || 'Passwords must match',
      ],
    };
  },
  props: {
    source: String,
  },
  computed: {
    primaryColor() {
      return this.$store.getters.getLoggedInUserSelectedBusinessBrandingPrimary;
    },
    secondaryColor() {
      return this.$store.getters.getLoggedInUserSelectedBusinessBrandingSecondary;
    },
    accentColor() {
      return this.$store.getters.getLoggedInUserSelectedBusinessBrandingAccent;
    },
  },
  mounted() {
    let bodyStyles = document.body.style;
    bodyStyles.setProperty('--primary-color', this.primaryColor);
    bodyStyles.setProperty('--secondary-color', this.secondaryColor);
    bodyStyles.setProperty('--accent-color', this.accentColor);
  },
  created() {
    // Check if user token exist
    this.spinner(false);
  },
  methods: {
  
    /**
    * To prompt the backend call that logs the user in.
    * @function
    * @param {object} event - The click event that prompted this function.
    * @returns {object} A promise that will either return an error message
    * or display the success screen
    */
    login() {
      const self = this;
      if (this.$refs['form-1'].validate()) {

        this.spinner(true);
        const url = `${Env.url}/api/v1/users/login`;
        NormalApi.postApi(url, {
          'api-token': Env.apiToken 
        }, this.user)
        .then((response) => {
          this.spinner(false);
          if(response.data.payload.hasOwnProperty("two_factor")){
            // If two factor is enabled 
             this.$store.dispatch('SET_USER_LOGIN_STEP', '2_factor_authenticate');
             return false;
          } else if(response.data.payload.hasOwnProperty("change_password")) { 
              let resetPassToken = response.data.payload.reset_token;
              // if token is available
              if(resetPassToken){
                this.snackbar({
                  text: response.data.msg,
                  timeout: 3000,
                  open: true,
                });
                this.$router.push({ name: 'ResetPassword', query: { token:resetPassToken }});
                return false;
              }
          }
   
          /**
           * Save user token and user details in store
           */
          this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_token');
          this.$store.dispatch('SET_USER_TOKEN', response.data.payload.token);
          this.$store.dispatch('SET_USER_DETAILS', response.data.payload.user);
          this.snackbar({
            text: response.data.msg,
            timeout: 3000,
            open: true,
          });
          return response.data.payload.user
        })
        .then((loggedInUserdetails) => {
            /**
             * Before we show them the business list we need to check the 2 factor 
             * If 2 factor is enabled we must give them popup where they can fill in the value
            */
            if(loggedInUserdetails){
              this.fetchUserBusinessList();
            }   
        }).catch( (err) => {
          this.spinner(false);
           this.snackbar({
            text: err.response.data.msg,
            timeout: 4000,
            open: true,
          });
        });
      } else {
        
        this.snackbar({
          text: 'Validation error.',
          timeout: 4000,
          open: true,
        });
      }
    },

    /**
     * Fetch account list, if multiple show User account list else set the default
     */
    fetchUserBusinessList() {
      /**
       * Get user account list
       */
      const url = `${Env.url}/api/v1/users/businesses`;
      AuthApi.getApi(url, {})
      .then((res) => {
      // Store user account in store
        this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_accountlist');
        if(res.data.hasOwnProperty("payload") ){
          this.$store.dispatch('SET_USER_ACCOUNTS', res.data.payload);
        }
        this.snackbar({
          text: res.data.msg ? res.data.msg : 'Successfully fetched businesses.',
          timeout: 3000,
          open: true,
        });
        return res.data.payload;
      })
      .then((businesses) => {
        /**
        * If account is more than 1 set popup to choose which account to login
        * Else if only one account account found autoselect that account
        */
        this.snackbar({
          text: 'Creating account session.',
          timeout: 3000,
          open: true,
        });

        // If only 1 business, activate it 
        if (businesses.length === 1) {
          AuthApi.setActiveBusiness(businesses[0].id).then((res) => {
            if(res) {
              this.getBusinessBranding();
              this.spinner(false);
              this.snackbar({
                text: 'Successfully logged in.',
                timeout: 4000,
                open: true,
            });
            this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_completed');
            this.$router.push({ name: 'Applications' }); 
            } else {
              this.spinner(false);
              this.snackbar({
                text: 'Please try again later',
                timeout: 4000,
                open: true,
              });
            }
          });
        } else {
          // There are multiple account show account list popup
          this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_chooseAccount');
        }
      }).catch(err => {
        this.snackbar({
          text: err.response.data.msg,
          timeout: 4000,
          open: true,
        });
        this.$store.dispatch('SET_USER_LOGIN_STEP', 'at_chooseAccount');
      });
    },

    /**
     * Get selected business branding
     */

    getBusinessBranding() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}`;
      AuthApi.getApi(url)
        .then((res) => {
          this.$store.dispatch('SET_USER_SELECTED_ACCOUNT_BRANDING', res.data.payload.branding);  
          if(res.data.payload.branding && res.data.payload.branding.brand_colors){
            this.$vuetify.theme.themes.light.primary = res.data.payload.branding.brand_colors.primary;
            this.$vuetify.theme.themes.light.secondary = res.data.payload.branding.brand_colors.secondary;
            this.$vuetify.theme.themes.light.accent =  res.data.payload.branding.brand_colors.accent;
          }
        })
        .catch(err => {
          console.log('Cannot fetch branding.')
        })
    },
    

    ...mapActions({
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),

  },
};
</script>

